import { AxiosResponse } from 'axios';
import apiClient from '@/api/apiClient';
import getSocketIdRequestTransformer from '@/api/requestTransformers/socketId.transformer';
import getActualOrdersResponseTransformer from '@/api/responseTransformer/tv/actualOrdersTransformer';
import TakeAway from '@/models/takeAway';

export default {
  async getActualOrdersByPlaceId(placeId: string): Promise<TakeAway[]> {
    return apiClient.get(
      `/tv/order/list/${placeId}`,
      {
        transformRequest: getSocketIdRequestTransformer,
        transformResponse: getActualOrdersResponseTransformer,
      },
    )
      .then(({ data }: AxiosResponse<TakeAway[]>): TakeAway[] => data);
  },
};
